<!-- 
Expander panel showing the levy parameters.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelParameters)"
    >
      Levy &amp; risk calculation parameters
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.LevyParameters"/>
        <v-card-text class="pa-0">
          <levy-parameters-panel 
            :levy-parameters="levyCollectionProvider.levyParameters" 
            :levy-collection="levyCollection"
            :for-provider="isLevyEstimator"
          />
          <v-btn  
            v-if="isLevyEstimator && !playgroundIsActive"
            flat color="primary"
            @click="$emit('click:showPlayground')"
          >
            <v-icon class="mr-2">tune</v-icon>
            Levy estimator
          </v-btn>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import LevyParametersPanel from "@/components/levy-collection-providers/calculation/LevyParametersPanel.vue";
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";

export default {
  components: { LevyParametersPanel },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
